import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from '../../../services/functions.service';
//import { Firestore, collectionData, collection } from '@angular/fire/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AgmMap } from '@agm/core';
import { map } from 'rxjs/operators';
import { ImageModalComponent } from 'src/app/generic-components/image-modal/image-modal.component';
import { environment } from 'src/environments/environment';
import { PaginationModel } from 'src/app/models/paginationModel';
import { FormBuilder } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ExportAlertChatLogComponent } from '../export-alert-chat-log/export-alert-chat-log.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-alert-chat-history-log-component',
  templateUrl: './alert-chat-history-log.component.html',
  styleUrls: ['./alert-chat-history-log.component.css'],
  providers: [NgxSpinnerService]
})
export class AlertChatHistoryLogComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  chatMessages: Array<any> = [];
  alertStatus: number;
  agentId: number;
  userId: number;
  logs:any;
  chatEmpty: boolean;
  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  @ViewChild('AgmMap', {static: true}) agmMap: AgmMap;
  constructor(
    private activatedRoute:ActivatedRoute,
    private apiService: ApiService,
    public functionsService: FunctionsService,
    private spinner:NgxSpinnerService,
    public pagination: PaginationModel,
    private modalService: NgbModal,
    private angularFireStore: AngularFirestore
    ) { 
      this.activatedRoute.params.subscribe(params => {
        this.pagination.AlertId = params['alertId'];
      });
      this.logs = [];
    }

  ngOnInit() {
    this.functionsService.setTitle('alert.activity');
    if(localStorage.getItem('language') != null){
      this.functionsService.useLanguageRed(this.language);
    }
    this.pagination.ChatHistory = true;
    this.fetchAlertLogs(); 
  }

  fetchAlertLogs(){
    this.spinner.show();
    this.apiService.getAlertLogs(this.pagination).subscribe(
      data => {
        var userId = data["alert"]["createdBy"];
        var user = data["alert"]["createdByName"];
        var agentId = data["alert"]["attendedBy"];
        var agent = data["alert"]["attendedByName"];
        var name ="";
        let messages$ = this.angularFireStore
          .collection<firebase.default.firestore.DocumentData>(`${environment.firebaseConfig.path}/${this.pagination.AlertId}/Messages`).valueChanges();
        
          messages$.pipe(
            map(chat => {
                chat.forEach(c => c.timestamp = c.timestamp * 1000);
                return chat.sort((a, b) => (a.timestamp > b.timestamp) ? 1 : -1);
            })
        ).subscribe(chat => {
          this.chatMessages = chat;
          var j = 0;
          var k = 0;
          var chat1 = this.chatMessages.reverse();
          while(j<chat1.length){
            if(chat1[j]){
              this.logs[k] = [];
              name = chat1[j]["senderName"] ? chat1[j]["senderName"] : (chat1[j]["ownerID"]==userId) ? 
              user : ((chat1[j]["ownerID"] == agentId) ? agent :"Rep. #" + chat1[j]["ownerID"]);
              this.logs[k][0] = "message_sent";
              switch(chat1[j]["contentType"]){
                case 1:
                  this.logs[k][1] = chat1[j]["profilePicLink"];
                  break;
                case 2:
                  this.logs[k][1] = "alert_activity.location_shared";
                  this.logs[k][5] = (chat1[j]["content"]).toString().split(',');
                  this.logs[k][6] = parseFloat(this.logs[k][5][0]);
                  this.logs[k][7] = parseFloat(this.logs[k][5][1]);
                  break;
                default:
                  this.logs[k][1] = chat1[j]["message"];
              }
              
              this.logs[k][2] = this.functionsService.convertUTCDateToLocalDateMessage(chat1[j]["timestamp"]);
              this.logs[k][3] = name;
              this.logs[k][4] = chat1[j]["contentType"];
              j++;
              k++;
            }
          }
          if(this.logs.length == 0){
            this.logs[0] = [];
            this.logs[0][0] = "chat_empty";
            this.logs[0][1] = "";
          }
          this.chatEmpty = this.logs[0][0]=="chat_empty"? true: false;
          this.spinner.hide();
        });
          
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  refreshLogs(){
    this.fetchAlertLogs();
  }

  openExportLog(){
    const modalRef = this.modalService.open(ExportAlertChatLogComponent, { size: 'md' });
    modalRef.componentInstance.alertId = this.pagination.AlertId;
  }
}


